exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".attribute-container[data-v-c05a2c0e]{display:grid;gap:15px 15px;grid-template-columns:4fr 4fr 4fr 1fr}.grid-right[data-v-c05a2c0e]{grid-column-end:-1;justify-self:end;align-self:end}\n", ""]);

